export default function titleCase(str: string) {
    const wordsArray = str.toLowerCase().split(/\s+/)

    const upperCased = wordsArray.map((word) => {
        return word.charAt(0).toUpperCase() + word.substring(1)
    })

    return upperCased.join(' ')
}
